import { useQueries } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

const fetchQuery = async (customerId: string, query: string) => {
  const { data } = await httpService.get((`${BASE_URL}/api/v2/user/${customerId}/home/uncategorized?${query}`));
  return data;
};

export const useUncategorizedTransactionsQuery = ({ customerId, query, isExpenses }: {customerId: string, query: string[], isExpenses: boolean}) => {
  if (isExpenses) {
    return useQueries(query.map((q) => ({
      queryKey: ['uncategorizedTransactions', q],
      queryFn: () => fetchQuery(customerId, q),
      refetchOnWindowFocus: false,
    })));
  }
  return [];
};
